module.exports = __webpack_public_path__ + "media/images/application/template/CPA-email-footer-732b023172fecf79b84a4efee9c4cc20.png";